import * as Selectors  from './selectors';
import { useSelector } from 'react-redux';


// -- User hooks --

// Selectors

export function useProfile() {
  return useSelector(state => Selectors.getProfile(state));
}


export function useUserID() {
  return useSelector(state => Selectors.getUserID(state));
}


export function useUserName() {
  return useSelector(state => Selectors.getUserName(state));
}


export function useLocations() {
  return useSelector(state => Selectors.getLocations(state));
}
